import React from 'react';
import { Activity, TrendingUp, TrendingDown, Clock, RefreshCw } from 'lucide-react';

const ProviderPerformanceCard = ({ provider, stats }) => {
  const getStatusColor = (rate) => {
    if (rate >= 95) return 'bg-green-100 text-green-800';
    if (rate >= 85) return 'bg-yellow-100 text-yellow-800';
    return 'bg-red-100 text-red-800';
  };

  const getStatusIcon = (rate) => {
    if (rate >= 95) return <TrendingUp className="w-4 h-4" />;
    return <TrendingDown className="w-4 h-4" />;
  };

  const providerName = provider?.charAt(0)?.toUpperCase() + provider?.slice(1);

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
            <Activity className="w-5 h-5 text-purple-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{providerName}</h3>
            <p className="text-sm text-gray-500">{stats?.total} total calls</p>
          </div>
        </div>
        <div className={`px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1 ${getStatusColor(parseFloat(stats?.successRate))}`}>
          {getStatusIcon(parseFloat(stats?.successRate))}
          {stats?.successRate}%
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Successful Calls */}
        <div className="bg-green-50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-2 h-2 bg-green-600 rounded-full"></div>
            <span className="text-xs font-medium text-green-900">Successful</span>
          </div>
          <p className="text-2xl font-bold text-green-900">{stats?.successful}</p>
        </div>

        {/* Failed Calls */}
        <div className="bg-red-50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-2 h-2 bg-red-600 rounded-full"></div>
            <span className="text-xs font-medium text-red-900">Failed</span>
          </div>
          <p className="text-2xl font-bold text-red-900">{stats?.failed}</p>
        </div>

        {/* Avg Response Time */}
        <div className="bg-blue-50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-1">
            <Clock className="w-3 h-3 text-blue-900" />
            <span className="text-xs font-medium text-blue-900">Avg Response</span>
          </div>
          <p className="text-2xl font-bold text-blue-900">{stats?.avgResponseTime}ms</p>
        </div>

        {/* Avg Retry Count */}
        <div className="bg-orange-50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-1">
            <RefreshCw className="w-3 h-3 text-orange-900" />
            <span className="text-xs font-medium text-orange-900">Avg Retries</span>
          </div>
          <p className="text-2xl font-bold text-orange-900">{stats?.avgRetryCount}</p>
        </div>
      </div>
    </div>
  );
};

export default ProviderPerformanceCard;